import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Store } from '@ngxs/store';
import { map } from 'rxjs/operators';
import { InitApp } from '../state/app.actions';
import { AppState } from '../state/app.state';

/**
 * Guards the rest of the app that depends on a user from loading before
 * The user has been set
 */
@Injectable({ providedIn: 'root' })
export class UserExistsGuard implements CanActivate {
  constructor(private store: Store) {}

  canActivate() {
    // Fetch user. Note this guard is provded only once for the top level application
    return this.store.dispatch(InitApp).pipe(
      map(() => {
        const user = this.store.selectSnapshot(AppState.selectUser);

        return !!user;
      })
    );
  }
}
